/* eslint-disable import/prefer-default-export */
import { addToasty } from 'services/toasty/actions'
import {
  SET_FEATURE_TRACKING_DATA,
} from 'services/feature-tracking/actions'
import { SET_EVENT_VIDEO_AUDIO_CHANGED } from 'services/event-tracking/actions'
import { addNewRelicAction } from 'services/app/_newrelic'
import isNil from 'lodash/isNil'

export function videoOverlayToggleAddToasty ({ after }) {
  return after(SET_FEATURE_TRACKING_DATA, async ({ action, state, dispatch }) => {
    const { staticText } = state
    const { payload } = action
    const { data } = payload
    const shownOrHidden = data.get('disableVideoInfo') ? 'videoInformationHidden' : 'videoInformationShown'
    const message = staticText.getIn(['data', 'myAccountSettingsV2', 'data', shownOrHidden])
    dispatch(addToasty(message))
  }).when(({ state, action }) => {
    const { resolver } = state
    const { payload } = action
    const { data } = payload
    return resolver.get('path').includes('video/')
      && data.has('disableVideoInfo')
  })
}

export function watchVideoAudioChangeForNewRelicEvent ({ after }) {
  return after(SET_EVENT_VIDEO_AUDIO_CHANGED, async ({ action, state }) => {
    const { user } = state
    const anonymousUuid = user.getIn(['data', 'anonymousUuid'])
    const userUuid = user.getIn(['data', 'uuid'])
    const { payload: { lang } } = action
    const newRelicData = {
      anonymousUuid,
      userUuid,
      selectedAudioTrack: lang,
      audioTrackChangeSuccess: !isNil(lang),
    }
    addNewRelicAction('VideoAudioChange', newRelicData)
  })
}
